// @flow
//
// this is not a react component, purely some simple bindings for a simple mobile nav toggle

class MobileNav {
  mobileNavNav: ?HTMLElement
  handleToggleClick: () => void
  handleCloseClick: () => void

  constructor() {
    const toggleTrigger = document.getElementById('mobile-nav-toggle')
    const closeTrigger = document.getElementById('mobile-nav-close')
    if (toggleTrigger && closeTrigger) {
      this.mobileNavNav = document.getElementById('mobile-nav-nav')
      this.handleToggleClick = this.handleToggleClick.bind(this)
      this.handleCloseClick = this.handleCloseClick.bind(this)
      toggleTrigger.addEventListener('click', this.handleToggleClick)
      closeTrigger.addEventListener('click', this.handleCloseClick)
    }
  }

  handleToggleClick(/*e: SyntheticMouseEvent<HTMLButtonElement>*/) {
    this.mobileNavNav && this.mobileNavNav.classList.toggle('is-active')
  }

  handleCloseClick(/*e: SyntheticMouseEvent<HTMLButtonElement>*/) {
    this.mobileNavNav && this.mobileNavNav.classList.remove('is-active')
  }
}

export default MobileNav
